import { type IIconsVector, type IStatusProps, Status } from 'shared/ui'

import { type TollFreeProfileNumber } from 'entities/Compliance/model'
import { type IResponseNumberVerifiedStatus } from 'entities/Phone/api/types'
import styles from './styles.module.scss'

type IStatusLineProps = {
  tollFree: TollFreeProfileNumber
}

const statusTitleMap: Record<IResponseNumberVerifiedStatus | string, string> = {
  'Under Review': 'In Carrier Review',
  Verified: 'Approved',
  'Internal Review': 'Pending Review',
  Denied: 'Rejected',
  Blocked: 'Blocked',
}

const statusIntentMap: Record<string, IStatusProps['intent']> = {
  Verified: 'positive',
  Denied: 'negative',
  Blocked: 'negative',
  'Under Review': 'informative',
  'Internal Review': 'informative',
}

const statusIconMap: Record<string, IIconsVector> = {
  Verified: 'check2',
  Denied: 'failed',
  Blocked: 'failed',
  'Under Review': 'clock',
  'Internal Review': 'clock',
}

export const StatusLine = ({ tollFree }: IStatusLineProps) => {
  return (
    <div className={styles.statusLineWrapper}>
      <Status
        title={statusTitleMap[tollFree.status]}
        intent={statusIntentMap[tollFree.status]}
        icon={statusIconMap[tollFree.status]}
        emphasis={'high'}
      />
    </div>
  )
}
